var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
export class FixedFooterNavigationViewModel {
    constructor(opts) {
        this.patientResearchDashboardUIManager = opts.container.patientResearchDashboardUIManager;
        this.studyManager = opts.container.studyManager;
    }
    get selectedBottomNavigationButton() {
        return this.patientResearchDashboardUIManager.selectedBottomNavigationButton;
    }
    get showResearchBadge() {
        if (this.studyManager.allPatientConsentsByStudyForSearchTotals.value === NOT_LOADED)
            return false;
        return this.studyManager.allPatientConsentsByStudyForSearchTotals.value.pending > 0;
    }
    goToPage(value) {
        this.patientResearchDashboardUIManager.goToPage(value);
    }
}
__decorate([
    computed
], FixedFooterNavigationViewModel.prototype, "selectedBottomNavigationButton", null);
__decorate([
    computed
], FixedFooterNavigationViewModel.prototype, "showResearchBadge", null);
